import styled from 'styled-components'

export const DetailSkeletonRoot = styled.div`
    display: flex;
    flex-direction: column;
    gap: 22px;
`;

export const DetailSkeletonHeader = styled.div`
    margin-bottom: 6px;
`;

export const DetailSkeletonBody = styled.div`
    max-width: 720px;
    margin-top: 30px;
    display: flex;
    flex-direction: column;
    gap: 14px;
`;
